import { useNavigate, useLocation } from 'react-router-dom'
import { Menu } from 'antd'
import {
  DashboardOutlined,
  MessageOutlined,
  FileTextOutlined,
  AuditOutlined,
  AlertOutlined,
  ApartmentOutlined,
  BookOutlined,
  SettingOutlined,
  TeamOutlined,
  ToolOutlined,
} from '@ant-design/icons'
import type { MenuProps } from 'antd'
import { useAuthStore } from '@/stores/authStore'

type MenuItem = Required<MenuProps>['items'][number]

interface NavEntry {
  item: MenuItem
  permission?: string
  role?: string
}

const navEntries: NavEntry[] = [
  {
    item: { key: '/dashboard', label: '工作台', icon: <DashboardOutlined /> },
  },
  {
    item: { key: '/after-sales', label: '售后问题管理', icon: <ToolOutlined /> },
  },
  {
    item: { key: '/messages', label: '消息中心', icon: <MessageOutlined /> },
    permission: 'message:read',
  },
  {
    item: { key: '/drafts', label: '工单草稿', icon: <FileTextOutlined /> },
    permission: 'draft:read',
  },
  {
    item: { key: '/tickets', label: '工单跟踪', icon: <AuditOutlined /> },
    permission: 'ticket:read',
  },
  {
    item: { key: '/sla', label: '响应时限提醒', icon: <AlertOutlined /> },
    permission: 'sla:read',
  },
  {
    item: { key: '/sla/rules', label: '响应时限设置', icon: <SettingOutlined /> },
    permission: 'user:manage',
    role: 'admin',
  },
  {
    item: { key: '/group-bindings', label: '群映射', icon: <ApartmentOutlined /> },
    permission: 'binding:read',
  },
  {
    item: { key: '/knowledge', label: '知识条目', icon: <BookOutlined /> },
  },
  {
    item: { type: 'divider' },
  },
  {
    item: { key: '/system/reception-shares', label: '接待临时代管', icon: <TeamOutlined /> },
    permission: 'reception_share:manage',
    role: 'admin',
  },
  {
    item: { key: '/system/users', label: '用户管理', icon: <TeamOutlined /> },
    permission: 'user:manage',
  },
  {
    item: { key: '/system/job-runs', label: '任务运行', icon: <SettingOutlined /> },
    permission: 'system:health_read',
  },
]

export default function SidebarNav() {
  const navigate = useNavigate()
  const location = useLocation()
  const permissions = useAuthStore((s) => s.permissions)
  const roles = useAuthStore((s) => s.roles)

  const items = navEntries
    .filter((entry) => !entry.permission || permissions.includes(entry.permission))
    .filter((entry) => !entry.role || roles.includes(entry.role))
    .map((entry) => entry.item)

  // 确定当前选中的菜单项
  const selectedKey = [...items]
    .sort((a, b) => String(b?.key || '').length - String(a?.key || '').length)
    .find((item) => {
      const key = item?.key as string
      return location.pathname === key || location.pathname.startsWith(key + '/')
    })?.key as string

  return (
    <Menu
      mode="inline"
      selectedKeys={selectedKey ? [selectedKey] : []}
      items={items}
      onClick={({ key }) => navigate(key)}
      style={{ borderRight: 0 }}
    />
  )
}
